export default __webpack_public_path__ + "static/media/36I-102623_-15523_0.e38aa1fb.jpg";